
const getDriveDetail = state => state?.driveDetails?.drivesDetail

const selector = {
    getDriveDetail
}

export default selector
